import React from 'react';
import { Row, Col } from 'antd';

import {
  FullBOUserResponseModel,
  ResourceDownloadResponse,
} from 'api/backofficeApiClient';
import EntityInfo from './EntityInfo';
import BankingInfo from './BankingInfo';
import PricingAgreement from './PricingAgreement';
import GeneralInfo from './GeneralInfo';
import { LoadRecruiterDetailsOptions } from 'features/recruiter/RecruiterDetailsPage/types';
import { checkIsCompanyOwner } from 'utils/userRolesUtils';
import { useAppSelector } from 'hooks/useAppSelector';
import { userSelector } from 'redux/selectors/authenticationSelectors';

type Props = {
  fullProfile: FullBOUserResponseModel;
  entityInfoFile?: ResourceDownloadResponse;
  bankingInfoFile?: ResourceDownloadResponse;
  loadFullProfile: (options?: LoadRecruiterDetailsOptions) => Promise<void>;
};

export default function PrimaryInfo(props: Props) {
  const {
    fullProfile,
    entityInfoFile,
    loadFullProfile,
    bankingInfoFile,
  } = props;
  const user = useAppSelector(userSelector);
  const isCompanyOwner = checkIsCompanyOwner(user);

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} md={12} className="d-flex">
        <GeneralInfo profile={fullProfile} loadFullProfile={loadFullProfile} />
      </Col>
      {isCompanyOwner && (
        <>
          <Col xs={24} md={12} className="d-flex">
            <PricingAgreement
              profile={fullProfile}
              loadFullProfile={loadFullProfile}
            />
          </Col>
          <Col xs={24} md={12} className="d-flex">
            <EntityInfo
              profile={fullProfile}
              entityInfoFile={entityInfoFile}
              loadFullProfile={loadFullProfile}
            />
          </Col>
          <Col xs={24} md={12} className="d-flex">
            <BankingInfo
              profile={fullProfile}
              loadFullProfile={loadFullProfile}
              bankingInfoFile={bankingInfoFile}
            />
          </Col>
        </>
      )}
    </Row>
  );
}
